<template>
  <div id="skeleton">
    <div class="pic flex-dis" v-if="removeImg">
       <i style="font-size: 50px; color: #ccc" class=" el-icon-picture-outline"></i>
    </div>
    <div class="flex-dis pro-mg">
        <div class="pro-con">
            <div class="list" v-for="o in 4" :key="o+'i'"></div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  props:['removeImg'],
  data() {
    return {
    };
  },
};
</script>
<style lang="less">
#skeleton {

  .pic {
    width: 100%;
    height: 360px;
    padding: 65px;
    background: #f2f2f2;
       flex-direction: column;
      justify-content: center;
      align-items: center;
  }
  .pro-mg{
       flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 20px 0;
  }
    .list{
        width: 100%;
        height: 20px;
        margin: 10px 0;
        background: #f2f2f2;
        border-radius: 5px;
    }
    .list:last-child{
        width: 80%;
    }
    .list:first-child{
        width: 40%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/skeleton.vue